module.exports = __webpack_public_path__ + "static/assets/a0e856f32e8f5a09e179352d449b0a68.svg";